export function host (url) {
	const host = url.replace(/^https?:\/\//, '').replace(/\/.*$/, '')
	const parts = host.split('.').slice(-3)
	if (parts[0] === 'www') parts.shift()
	return parts.join('.')
}

export function timeAgo (time) {
	const between = Date.now() / 1000 - new Date(time).getTime() / 1000
	if (between < 3600) {
		return pluralize(~~(between / 60), ' minute')
	} else if (between < 86400) {
		return pluralize(~~(between / 3600), ' hour')
	} else {
		return pluralize(~~(between / 86400), ' day')
	}
}

export function gender (genderId) {
	var gender = 'Male';
	if (genderId==2){
		gender = 'Female'
	}
	return gender;
}

export function cardType (typeId) {
	var cardType = 'KTP';
	if (typeId==1){
		cardType = 'SIM'
	} else if (typeId==2){
		cardType = 'Passport'
	}
	return cardType;
}

function pluralize (time, label) {
	if (time === 1) {
		return time + label
	}
	return time + label + 's'
}

export function bloodType(typeId){
	var bloodString = '-';
	var bloodObject = {};
	var bloods = [
		{ text: 'O', value: 0 },
		{ text: 'O+', value: 1 },
		{ text: 'O-', value: 2 },
		{ text: 'A', value: 3 },
		{ text: 'A+', value: 4 },
		{ text: 'A-', value: 5 },
		{ text: 'B', value: 6 },
		{ text: 'B+', value: 7 },
		{ text: 'B-', value: 8 },
		{ text: 'AB', value: 9 },
		{ text: 'AB+', value: 10 },
		{ text: 'AB-', value: 11 },
	];
	bloods.forEach((blood)=>{
		bloodObject[blood.value] = blood.text;
	})
	if (bloodObject[typeId]){
		bloodString = bloodObject[typeId];
	}
	return bloodString;
}


// WEBPACK FOOTER //
// src/util/filters.js